export default "__VITE_ASSET__e4ccd300__"